namespace GeniuzPOS.InitialData {
    export class PsPanelGroupButtonColumns {
        static columnsKey = 'InitialData.PsPanelGroupButton';
    }
}
